import GptCreate from './gpt';
import HtlbidCreate from './htlbid';
import logger from './logger';
export const InsertAd = ({ adOptions, adCallbacks }) => {
    const { rootElm, network, sizes, adTargeting, bidders, bidderTimeout, adProvider } = adOptions;
    if (!network) {
        throw new Error('"network" can not be empty string');
    }
    const divId = rootElm.getAttribute('id')?.trim() || `div-${Math.round(Math.random() * 10000)}`;
    rootElm.setAttribute('id', divId);
    const option = {
        bidders,
        bidderTimeout,
        adTargeting,
    };
    const gptApi = adProvider === 'htlbid' ? HtlbidCreate(option) : GptCreate(option);
    gptApi.addPlacement({
        divId,
        network,
        sizes,
    });
    gptApi.addEventListener('slotRenderEnded', (event) => {
        if (event.slot.getSlotElementId() === divId) {
            logger.log('ads,widget,gpt,slotRendered', event);
            const renderEvent = event;
            if (renderEvent.isEmpty) {
                adCallbacks.onAdUnfilled();
            }
            else {
                adCallbacks.onAdFilled();
            }
        }
    });
    gptApi.addEventListener('impressionViewable', (event) => {
        if (event.slot.getSlotElementId() === divId) {
            logger.log('ads,widget,gpt,impressionViewable', event);
            adCallbacks.onAdViewable();
        }
    });
    return gptApi;
};
export default InsertAd;
//# sourceMappingURL=InsertAd.js.map